<template>
	<form>
		<div class="userlogin">
			<div class="headline">
				<div class="text_bold">忘记密码</div>
			</div>
			<div class="userlogin_box">
				<div class="input_box">
					<input class="my_input" placeholder="请输入手机号" type="tel" maxlength="11" v-model="info.telNumber"
						@input="e => input(e, 'telNumber')" :focus="isFocused" />
					<div class="input_Box_close" v-if="info.telNumber.length > 0"
						@click.stop.prevent="clearIcon('telNumber')">
						<img class="image_close" src="@/assets/image/icon/loginClose.png" alt="">
					</div>
				</div>
				<div class="input_box">
					<input class="my_input codeInput" placeholder="请输入验证码" type="tel" maxlength="6" v-model="info.code"
						@input="e => input(e, 'code')"/>
					<div class="get_code">
						<div v-if="codeShow" style="display: flex;align-items: center;">
							<div class="get_code" style="color: #CACACA;">
								<van-count-down :time="59000" format="(sss)" @finish="timUp"
									style="color: #CACACA;" />秒后重新发送
							</div>
						</div>
						<div class="get_code" v-else @click="codeBtn">
							发送验证码
						</div>
					</div>
				</div>
				<div class="input_box">
					<input maxlength="20" @input="e => input(e, 'password')" :type="passwordShow ? 'text' : 'password'"
						v-model="info.password" placeholder="请输入新密码" class="my_input" />
					<div class="input_Box_close" @click.stop.prevent="passwordShow = !passwordShow"
						v-if="info.password.length > 0">
						<img :class="passwordShow ? 'image_show' : 'image_hide'"
							:src="passwordShow ? require('@/assets/image/set/password1.png') : require('@/assets/image/set/password2.png')"
							alt="">
					</div>
				</div>
				<div class="input_box">
					<input maxlength="20" @input="e => input(e, 'confirm_password')"
						:type="passwordCopyShow ? 'text' : 'password'" v-model="info.confirm_password"
						placeholder="请再次输入新密码" class="my_input" />
					<div class="input_Box_close" @click.stop.prevent="passwordCopyShow = !passwordCopyShow"
						v-if="info.confirm_password.length > 0">
						<img :class="passwordCopyShow ? 'image_show' : 'image_hide'"
							:src="passwordCopyShow ? require('@/assets/image/set/password1.png') : require('@/assets/image/set/password2.png')"
							alt="">
					</div>
				</div>
				<div class="btn">
					<single-button @know='resetPassword' v-if="show" text="确定"
						background="linear-gradient( 90deg, #1D1D1D 0%, #5B4E3F 100%)" width="600rpx" height="100rpx"
						color="#FFDB89" fontSize="32rpx" />
					<single-button v-else background="#8E8E8E" text="确定" width="600rpx" height="100rpx" color="#fff"
						fontSize="32rpx" />
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import { RE_PHONE_NUMBER } from "@/utils/constants.js"
import { sendSms } from "@/api/auth.js"
import { phoneModifyPassword } from "@/api/user.js"
import md5 from 'js-md5'

export default {
	name: 'ForgetPassword',
	props: {
		isInputFocus: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			show: false,
			info: {
				telNumber: "",
				password: "",
				confirm_password: "",
				code: ''
			},
			min: 6,
			max: 11,
			passwordShow: false,
			passwordCopyShow: false,
			codeShow: false,
			isFocused: false
		}
	},
	watch: {
		info: {
			handler(val) {
				this.show = val.telNumber.length === this.max &&
					val.code.length > 0 &&
					val.password.length >= this.min &&
					val.confirm_password.length >= this.min
			},
			deep: true
		}
	},
	mounted() {
		if (this.isInputFocus) {
			this.onFocus()
		}
	},
	methods: {
		onFocus() {
			this.isFocused = true
		},
		timUp() {
			this.codeShow = false
		},
		clearIcon(type) {
			if (type === 'telNumber') {
				this.info.telNumber = ''
			}
		},
		input(e, name) {
			this.$nextTick(() => {
				let value = e.target.value
				if (name === 'telNumber' || name === 'code') {
					// 手机号和验证码只允许数字
					value = value.replace(/[^\d]/g, '')
					if (name === 'telNumber' && value.length > this.max) {
						value = value.slice(0, this.max)
					} else if (name === 'code' && value.length > 6) {
						value = value.slice(0, 6)
					}
				} else {
					// 密码允许字母和数字
					value = value.replace(/[^a-zA-Z0-9]/g, '')
				}
				this.info[name] = value
			})
		},
		async codeBtn() {
			if (!this.info.telNumber) {
				this.$toast('请输入手机号')
				return
			}
			if (!RE_PHONE_NUMBER.test(this.info.telNumber)) {
				this.info.telNumber = ''
				this.$toast('手机号格式不正确')
				return
			}

			const res = await sendSms({
				phone: this.info.telNumber,
				action: 'reset'
			})

			if (res.code === 200) {
				this.codeShow = true
				this.$toast('验证码已发送，请注意查收')
			} else {
				this.$toast(res.msg)
			}
		},
		async resetPassword() {
			const res = await phoneModifyPassword({
				phone: this.info.telNumber,
				code: this.info.code,
				password: md5(this.info.password),
				rePassword: md5(this.info.confirm_password)
			})

			if (res.code === 200) {
				this.$toast(res.msg)
				this.$emit("send", 1)
			} else {
				this.$toast(res.msg)
				this.info = {
					...this.info,
					password: '',
					confirm_password: '',
					code: ''
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.codeInput{
	width: 5rem;
}
.userlogin {
	.headline {
		padding-bottom: 0.7rem;
		display: flex;
		align-items: center;
		justify-content: center;

		.text_bold {
			font-weight: bold;
			font-size: 0.8rem;
			color: #1D1D1D;
		}
	}

	.userlogin_box {
		width: 15rem;
		margin: 0 auto;

		.input_box {
			width: 100%;
			padding: 1.5rem 0 0.5rem;
			border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			color: #1D1D1D;
			font-size: 0.8rem;

			.get_code {
				font-size: 0.6rem;
				color: #855200;
				display: flex;
				align-items: center;
				justify-content: flex-end;
			}

			.my_input {
				color: #1D1D1D;
				font-size: 0.8rem;
				flex: 1;
				border: none;
				outline: none;

				&::placeholder {
					color: #8E8E8E;
				}
			}

			.input_Box_close {
				width: 2.5rem;
				padding-right: 0.25rem;
				display: flex;
				align-items: center;
				justify-content: flex-end;

				img {
					display: block;
					width: 0.6rem;
					height: 0.6rem;
				}
			}
		}

		.btn {
			margin-top: 1.7rem;
			margin-bottom: 1rem;
		}
	}
}
</style>